<circle-progress
  [percent]="percent"
  [radius]="radius"
  [outerStrokeColor]="'#22307E'"
  [innerStrokeColor]="'rgba(207,212,229,0.4)'"
  [animation]="true"
  [animationDuration]="300"
  [clockwise]="true"
  [outerStrokeWidth]="16"
  [innerStrokeWidth]="16"
  [space]="-16"
  [title]="title"
  [titleColor]="'#22307E'"
  [showTitle]="true"
  [showSubtitle]="false"
  [responsive]="responsive"
></circle-progress>
